<plp-components-top-pagination class="top-pagination"></plp-components-top-pagination>

@if (productListData()) {
	<div class="hmf-px-s hf-grid">
		@for (plpProduct of productVOs(); track $index + plpProduct.parentCatentryId) {
			<div class="hmf-mb-m product-card hmf-display-flex hmf-flex-column hf-col-12 hf-col-xsm-6 hf-col-md-4 hf-col-xlg-3">
				@if ((productDetails()[plpProduct.parentCatentryId || plpProduct.catentryId]); as pld) {
					<a
						class="no-underline"
						[href]="(plpProduct.assetSeoUrl || plpProduct.dsgSeoUrl) + (pld.skuAttributes?.Color && pld.skuAttributes.Color.length > 0 ? '?color=' + pld.skuAttributes.Color[0] : '')">
						<div class="product-card-image">
							<hmf-product-image
								class="hmf-display-flex hmf-justify-content-center"
								[ecode]="plpProduct.parentPartnumber"
								[imageData]="imageData()[plpProduct.parentCatentryId || plpProduct.catentryId]"
								[productName]="plpProduct.name"
							></hmf-product-image>
						</div>

						<p class="product-description hmf-body-bold-m hmf-truncate-multiline-2 hmf-mt-xs">
							{{plpProduct.name}}
						</p>
						<!-- Product price, price range, was price ( see price in cart )-->
						<div class="product-pricing hmf-mb-xs">
							@if (pld.prices) {
								<hmf-price
									variant="vertical"
									[prices]="{
										maxListPrice: pld.prices.maxlistprice,
										maxOfferPrice: pld.prices.maxofferprice,
										minListPrice: pld.prices.minlistprice,
										minOfferPrice: pld.prices.minofferprice
									}"
									[isSeePriceInCart]="pld.mapPriceIndicator === 1"
									[isClearance]="pld.priceIndicator === 0">
								</hmf-price>
							}
						</div>
					</a>
				}
			</div>
		}
	</div>
 }
<plp-components-bottom-pagination [isColorBreakoutPage]="true"></plp-components-bottom-pagination>
